const p = "_chipGroup_z3lhx_1", o = {
  chipGroup: p
};
export {
  p as chipGroup,
  o as default
};
//# sourceMappingURL=index.es821.js.map
